export const parseSupportInfo = rawSupportInfo => {
  return Object.keys(rawSupportInfo).reduce((supportInfo, countryCode) => {
    return {
      ...supportInfo,
      [countryCode]: {
        email: rawSupportInfo[countryCode].support_email,
        phone: rawSupportInfo[countryCode].support_phone_number,
        zoneGenerationInfoURL: rawSupportInfo[countryCode].zone_generation_info_url
      }
    };
  }, {});
};
